export default {
  urlMatch() {
    const regEx = /#\/(.+)\/app\/([^/]+)\/?(\d+)?\/?/gm;

    return regEx.exec(window.location.hash);
  },

  shortName() {
    const match = this.urlMatch();

    if (match?.[1]) {
      return match[1];
    }
    const hashToLower = location.hash.toLowerCase();
    // the following don't fit the usual regex pattern
    if (
      hashToLower.includes("applibrary") ||
      hashToLower.includes("login") ||
      hashToLower.includes("forgot-password") ||
      hashToLower.includes("registration") ||
      hashToLower.includes("externallogin") ||
      hashToLower.includes("callbackinternal") ||
      hashToLower.includes("registerpasskey")
    ) {
      return location.hash.split("/")[1];
    }
    return "";
  },

  appGuid() {
    const match = this.urlMatch();

    if (match?.[2]) {
      if (match[2].includes("?")) {
        return match[2].split("?")[0];
      }

      return match[2];
    }

    return "";
  },

  contentId() {
    const match = this.urlMatch();

    if (match?.[3]) {
      return match[3];
    }

    return "";
  },
};
